import { h } from '@stencil/core';
import cn from 'classnames';
export class Badge {
  constructor() {
    this.type = undefined;
    this.color = undefined;
    this.textColor = undefined;
    this.label = undefined;
    this.size = 'small';
    this.lineHeight = undefined;
  }
  getStyles() {
    const styles = {};
    if (this.color) {
      styles.backgroundColor = this.color;
    }
    if (this.textColor) {
      styles.color = this.textColor;
    }
    if (this.lineHeight) {
      styles.lineHeight = this.lineHeight;
    }
    return styles;
  }
  render() {
    const hasType = !this.color && !this.textColor && this.type;
    const maxHeight = this.size === 'large' ? "60px" : "34px";
    return (h("div", { class: cn('badge', `badge--${this.size}`, hasType && `badge--${this.type}`), style: this.getStyles() }, h("pes-ellipsis", { maxHeight: maxHeight, content: this.label })));
  }
  static get is() { return "pes-badge"; }
  static get encapsulation() { return "shadow"; }
  static get originalStyleUrls() {
    return {
      "$": ["badge.scss"]
    };
  }
  static get styleUrls() {
    return {
      "$": ["badge.css"]
    };
  }
  static get properties() {
    return {
      "type": {
        "type": "string",
        "mutable": false,
        "complexType": {
          "original": "TBadgeUIType",
          "resolved": "\"\" | \"best-performance\" | \"best-seller\" | \"best-value\" | \"featured\" | \"new\"",
          "references": {
            "TBadgeUIType": {
              "location": "import",
              "path": "./types"
            }
          }
        },
        "required": false,
        "optional": true,
        "docs": {
          "tags": [],
          "text": "Type of badge"
        },
        "attribute": "type",
        "reflect": false
      },
      "color": {
        "type": "string",
        "mutable": false,
        "complexType": {
          "original": "string",
          "resolved": "string",
          "references": {}
        },
        "required": false,
        "optional": true,
        "docs": {
          "tags": [],
          "text": "background color of the badge"
        },
        "attribute": "color",
        "reflect": false
      },
      "textColor": {
        "type": "string",
        "mutable": false,
        "complexType": {
          "original": "string",
          "resolved": "string",
          "references": {}
        },
        "required": false,
        "optional": true,
        "docs": {
          "tags": [],
          "text": "text color of the badge"
        },
        "attribute": "text-color",
        "reflect": false
      },
      "label": {
        "type": "string",
        "mutable": false,
        "complexType": {
          "original": "string",
          "resolved": "string",
          "references": {}
        },
        "required": true,
        "optional": false,
        "docs": {
          "tags": [],
          "text": "Label of badge"
        },
        "attribute": "label",
        "reflect": false
      },
      "size": {
        "type": "string",
        "mutable": false,
        "complexType": {
          "original": "'large' | 'small'",
          "resolved": "\"large\" | \"small\"",
          "references": {}
        },
        "required": false,
        "optional": false,
        "docs": {
          "tags": [],
          "text": "Size of badge"
        },
        "attribute": "size",
        "reflect": false,
        "defaultValue": "'small'"
      },
      "lineHeight": {
        "type": "string",
        "mutable": false,
        "complexType": {
          "original": "string",
          "resolved": "string",
          "references": {}
        },
        "required": false,
        "optional": true,
        "docs": {
          "tags": [],
          "text": "Line height of badge"
        },
        "attribute": "line-height",
        "reflect": false
      }
    };
  }
}
